__turbopack_context__.v({
  "feedHeaderHeading": "view-module__4i3X5G__feedHeaderHeading",
});
